import React from 'react';

import styles from './styles.module.scss';

interface ILoaderProps {
  className?: string,
}

const Loader = ({ className }: ILoaderProps) => (
  <div className={`${styles.loader} ${className || ''}`}>
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Loader;
